export const BASE_URL = 'https://api.productcostoptimisation.co.uk/api/v1';

//customers
export const CUSTOMERS_URL = 'customer';

//quotulator
export const QUOTULATOR_URL = 'settings';

